import { HTMLAttributes } from 'react';
import classNames from 'classnames';

import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/css/v4-shims.css';
import './style.css';
import type { IconName, IconPrefix } from '@fortawesome/fontawesome-common-types';

type IconPrefixLegacy = IconPrefix | 'fa';
type Props = HTMLAttributes<HTMLElement> & {
  prefix?: IconPrefixLegacy;
  icon: IconName;
};

const getIcon = (prefix: IconPrefixLegacy, icon: IconName): [IconPrefixLegacy, IconName] => {
  if (icon === 'twitter') return ['fab', 'x-twitter'];

  return [prefix, icon];
};

export const Icon = ({ icon, prefix = 'fa', className, ...props }: Props) => {
  const [iconPrefix, iconName] = getIcon(prefix, icon);
  return <i className={classNames(`${iconPrefix} fa-${iconName}`, className)} {...props} />;
};
